import { Injectable } from '@angular/core';
import { CreateEffectMetadata } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { SciGuaduaHttpRequestHandler } from '@scifamek/guadua';
import { Observable } from 'rxjs';
import { createEntityEffects } from '../../../shared/base';
import {
  CreateApartmentCommand,
  GetApartmentsByBuildingIdCommand,
  DeleteApartmentCommand,
} from './apartment.commands';
import {
  CreatedApartmentEvent,
  GotApartmentsByBuildingIdEvent,
  DeletedApartmentEvent,
} from './apartment.events';

@Injectable()
export class ApartmentEffects {
  prefix = 'apartment';
  createApartmentCommand: Observable<Action<string>> & CreateEffectMetadata;
  getApartmentsByBuildingIdCommand: Observable<Action<string>> & CreateEffectMetadata;
  deleteApartmentCommand: Observable<Action<string>> & CreateEffectMetadata;

  constructor(private sciGuaduaHttpRequestHandler: SciGuaduaHttpRequestHandler) {
    this.createApartmentCommand = createEntityEffects(
      sciGuaduaHttpRequestHandler,
      CreateApartmentCommand,
      CreatedApartmentEvent,
      this.prefix,
    );
    this.getApartmentsByBuildingIdCommand = createEntityEffects(
      sciGuaduaHttpRequestHandler,
      GetApartmentsByBuildingIdCommand,
      GotApartmentsByBuildingIdEvent,
      this.prefix,
    );
    this.deleteApartmentCommand = createEntityEffects(
      sciGuaduaHttpRequestHandler,
      DeleteApartmentCommand,
      DeletedApartmentEvent,
      this.prefix,
    );
  }
}
